import { createElem } from './custom_form_fields/util/form_fields.js';

$(document).on("turbo:load", initContainers);

// Turbo renders a failed form submission (422) without a turbo:load, so the
// tabs would be left unhidden and the initial tab ignored.
$(document).on("turbo:render", function () {
    if ($("#container-tabs").length) {
        initContainers();
    }
});

function initContainers() {
    // turbo:render and turbo:load both fire on a normal visit; initialise each page once
    var $containerTabs = $("#container-tabs");
    if ($containerTabs.data("initialised")) {
        return;
    }
    $containerTabs.data("initialised", true);

    var cssClassesCount = $('#advanced').data('css_classes_count');

    // Initially hide branding, apps and publication tabs
    $("#container-branding-tab").hide();
    $("#container-apps-tab").hide();
    $("#container-publication-tab").hide();

    // Manage tabs
    $("#container-tabs").on("click", ".btn-group a", function (ev) {
        ev.preventDefault();
        var tabs = ["#container-overview-tab", "#container-branding-tab", "#container-apps-tab", "#container-publication-tab"];
        var anchor = ev.currentTarget.hash;
        var tab_index = tabs.indexOf(anchor);
        tabs.splice(tab_index, 1);
        $(tabs.join()).hide();
        $(anchor).show();
        $("#container-tabs .container-overview-tab, #container-tabs .container-branding-tab, #container-tabs .container-apps-tab, #container-tabs .container-publication-tab").removeClass("btn-info").addClass("btn-primary");
        $(anchor.replace("#", ".")).addClass("btn-info");
    });

    // Open on a given tab (e.g. Publication after a validation error)
    var initialTab = $("#container-tabs").data("initial-tab");
    if (initialTab) {
        $('#container-tabs .btn-group a[href="' + initialTab + '"]').trigger("click");
    }

    // Updates text and colour picker values from the preset dropdown
    function setColours(primaryColour, secondaryColour, buttonColour, backgroundColour, linkColour, fontColourTheme) {
        $("#container_style_attributes_primary_colour, #select_primary_colour").val(primaryColour);
        $("#container_style_attributes_secondary_colour, #select_secondary_colour").val(secondaryColour);
        $("#container_style_attributes_button_colour, #select_button_colour").val(buttonColour);
        $("#container_style_attributes_background_colour, #select_background_colour").val(backgroundColour);
        $("#container_style_attributes_link_colour, #select_link_colour").val(linkColour);
        $("#container_style_attributes_font_colour_theme").val(fontColourTheme);
    }

    // Update based on preset value
    $("body").on("change", "#container_colour_scheme", function () {
        switch (event.target.value) {
            case "seaBlue":
                setColours("#38648A", "#DCDEDA", "#2B4E70", "#FFFFFF", "#CC3848", "light");
                break;
            case "royalPurple":
                setColours("#5B4667", "#F7F7EA", "#7B6A86", "#FFFFFD", "#8A935C", "light");
                break;
            case "deepRed":
                setColours("#B7262B", "#EEE3DF", "#941C1F", "#FEF7F3", "#B7262B", "light");
                break;
            case "gold":
                setColours("#F0B900", "#F9F4F0", "#D8A500", "#FFFFFF", "#D00001", "light");
                break;
            case "lawn":
                setColours("#6FA638", "#F2F2F2", "#639532", "#FEFEFE", "#F4C300", "light");
                break;
            case "battleships":
                setColours("#434343", "#E9E9E9", "#686868", "#FEFEFE", "#6AA03C", "light");
                break;
        }
    });

    // Update appropriate text field hex value when colour picker value updated
    $('.color-field-set').on('input', function (event) {
        $("#container_style_attributes_" + $(this).attr("id").replace("select_", "")).val($(this).val());
    });

    // Update appropriate colour picker value when text field hex value updated
    $('.color-input-set').on('input', function () {
        $('#select_' + $(this).attr("id").replace("container_style_attributes_", "")).val($(this).val());
    });

    $('#link-fonts').on('click', function () {
        $('#fonts-glyph').toggleClass('glyphicon-chevron-down');
    });

    $('#link-advanced').on('click', function () {
        $('#advanced-glyph').toggleClass('glyphicon-chevron-down');
    });

    $('.delete-css-class').on('click', function () {
        deleteRow(this);
        if ($('.class-row').length <= 0) {
            $('#class-label, #css-label').hide();
        }
    });

    $('#add-css-class').on('click', function () {
        $(buildCssRow()).insertBefore($(this));
        cssClassesCount++;
        if ($('.class-row').length > 0) {
            $('#class-label, #css-label').show();
        }
    });

    function deleteRow(button) {
        var arr = $($(button).parent().parent()).find('.form-control')[0].id.split('_');
        arr.pop();
        arr[arr.length] = 'id';
        var id = arr.join('_');
        if($('#' + id).length > 0){
            var name = $('#' + id).attr('name');
            var idStartIndex = name.lastIndexOf('id');
            var replacement = '_destroy';
            var result = name.slice(0, idStartIndex) + replacement + name.slice(idStartIndex + 2);
            var input = createElem('input', null, {type: 'hidden', name: result, value: 1});
            $(input).insertAfter($('#' + id));

        }
        $(button).parent().parent().remove();
    }

    function buildCssRow() {
        var klassInputName = 'container[container_css_classes_attributes][' + cssClassesCount + '][name]';
        var klassInputId = 'container_container_css_classes_attributes_' + cssClassesCount + '_name';
        var klassInput = createElem('input', ['form-control'], {type: 'text', name: klassInputName, id: klassInputId});
        var klass = $(createElem('div', ['col-xs-5'])).append(klassInput);

        var cssInputName = 'container[container_css_classes_attributes][' + cssClassesCount + '][styles]';
        var cssInputId = 'container_container_css_classes_attributes_' + cssClassesCount + '_styles';
        var cssInput = createElem('input', ['form-control'], {type: 'text', name: cssInputName, id: cssInputId});
        var css = $(createElem('div', ['col-xs-5'])).append(cssInput);

        var deleteButton = createElem('input', ['btn', 'btn-sm', 'btn-danger', 'delete-css-class'], {
            type: 'button',
            value: 'x'
        });
        $(deleteButton).on('click', function () {
            deleteRow(this);
            if ($('.class-row').length <= 0) {
                $('#class-label, #css-label').hide();
            }
        });
        var del = $(createElem('div', ['col-xs-1'])).append(deleteButton);

        return $(createElem('div', ['row', 'class-row'])).append(klass, css, del);
    }

}
